import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Select } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { DROPDOWNS } from "../../../consts";
import { getCities } from "../../../utils/api";
import MetadataEditorModal from "../MetadataEditorModal";

const CreateModalContent = ({
  setOpen,
  createCallback,
  countryData,
  cropData,
}) => {
  const [form] = Form.useForm();
  const [currentCountry, setCurrentCountry] = useState(null);
  const [cityData, setCityData] = useState(null);
  const [isFetchingCities, setIsFetchingCities] = useState(false);

  const [metadataObj, setMetadataObj] = useState({});
  const [showMetadataEditor, setShowMetadataEditor] = useState(false);

  // Fetch Cities on Country Change
  useEffect(() => {
    const fn = async () => {
      setIsFetchingCities(true);
      const res = await getCities({ country: currentCountry });
      const cities = res?.data?.data || null;
      setCityData(
        cities?.map((city) => ({ value: city, label: city, key: city })),
      );
      form.setFieldsValue({ city: null });
      setIsFetchingCities(false);
    };
    if (currentCountry !== null) {
      fn();
    }
  }, [currentCountry]);

  const onFinish = (values) => {
    values.metadata = metadataObj || {};
    createCallback({ ...values, crops: [values.crops] });
    setOpen(false);
    form.resetFields();
    setMetadataObj({});
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      <Form
        id="createSiteForm"
        form={form}
        className="max-w-[80%]"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "name required",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          name="display_name"
          label="Display Name"
          rules={[
            {
              required: true,
              message: "display name required",
            },
          ]}
        >
          <Input placeholder="Display Name" />
        </Form.Item>
        <Form.Item
          name="country"
          label="Country"
          rules={[
            {
              required: true,
              message: "country required",
            },
          ]}
        >
          <Select
            className="min-w-[200px]"
            options={countryData}
            suffixIcon={<CheckCircleOutlined />}
            showSearch
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.value ?? "").toLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.value ?? "")
                .toLowerCase()
                .localeCompare((optionB?.value ?? "").toLowerCase())
            }
            onChange={(value) => setCurrentCountry(value)}
          />
        </Form.Item>
        <Form.Item
          name="city"
          label="City"
          rules={[
            {
              required: true,
              message: "city required",
            },
          ]}
        >
          <Select
            disabled={!currentCountry}
            className="min-w-[200px]"
            loading={isFetchingCities}
            options={cityData}
            showSearch
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.value ?? "").toLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.value ?? "")
                .toLowerCase()
                .localeCompare((optionB?.value ?? "").toLowerCase())
            }
          />
        </Form.Item>
        <div className="flex items-center justify-between">
          <Form.Item
            className="mr-2"
            name="lat"
            label="Latitude"
            rules={[
              {
                required: true,
                message: "latitude required",
              },
            ]}
          >
            <Input placeholder="Latitude" />
          </Form.Item>
          <Form.Item
            name="long"
            label="Longitude"
            rules={[
              {
                required: true,
                message: "longitude required",
              },
            ]}
          >
            <Input placeholder="Longitude" />
          </Form.Item>
        </div>
        <div className="flex items-center justify-between">
          <Form.Item
            name="size"
            label="Size"
            rules={[
              {
                required: true,
                message: "size required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="growing_environment"
            label="Env"
            initialValue={DROPDOWNS.GROWING_ENVIRONMENTS[0]?.value}
            rules={[
              {
                required: true,
                message: "environment required",
              },
            ]}
          >
            <Select options={DROPDOWNS.GROWING_ENVIRONMENTS} />
          </Form.Item>
        </div>
        <Form.Item
          name="crops"
          label="Crop"
          initialValue={cropData[0]?.id}
          rules={[
            {
              required: true,
              message: "crop required",
            },
          ]}
        >
          <Select
            options={cropData?.map((crop) => ({
              label: crop.display_name,
              value: crop.id,
            }))}
          />
        </Form.Item>
        <Form.Item
          name="metadata"
          label="Metadata"
          // rules={[
          //   {
          //     required: false,
          //     message: "Metadata required",
          //   },
          // ]}
        >
          <Button color="primary" onClick={() => setShowMetadataEditor(true)}>
            Edit Metadata
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
      <MetadataEditorModal
        name="Site Metadata"
        visible={showMetadataEditor}
        onClose={() => setShowMetadataEditor(false)}
        metadata={metadataObj}
        onUpdateMetadata={(updatedMetadata) => setMetadataObj(updatedMetadata)}
      />
    </div>
  );
};

export default CreateModalContent;
